// ==============================|| PRESET THEME - THEME5 ||============================== //
export const primaryColors = [
  "#F5FAFF",
  "#f0f6fe",
  "#ddebfc",
  "#c2ddfb",
  "#98c8f8",
  "#458EF4",   // "#68abf2",
  "#3681EB",
  "#2f6de1",
  "#2759ce",
  "#2549a8",
  "#244084",
  "#1a2951"
];
const Default = (mode) => {
  const contrastText = "#fff";

  // Define primary colors based on mode
  let primaryColors = [
    "#F5FAFF",
    "#f0f6fe",
    "#ddebfc",
    "#c2ddfb",
    "#98c8f8",
    "#458EF4",   // "#68abf2",
    "#3681EB",
    "#2f6de1",
    "#2759ce",
    "#2549a8",
    "#244084",
    "#1a2951"
  ];

  let secondaryColors = [
    "#F8F9FA",
    "#F8F9FA",
    "#F5F5F5",
    "#BCC1CA",
    "#D0D5DD",
    "#8996A4",
    "#5B6B79",
    "#3E4853",
    "#1D2630",
    "#131920",
  ];
  let errorColors = ["#FDE8E7", "#F25E52", "#F04134", "#EE3B2F", "#E92A21"];
  let warningColors = ["#FFF7E0", "#FFC926", "#FFBF00", "#FFB900", "#FFA900"];
  let infoColors = ["#E0F4F5", "#26B0BA", "#00A2AE", "#009AA7", "#008694"];
  let successColors = ["#E0F5EA", "#26B56E", "#00A854", "#00A04D", "#008D3A"];
  let devColors = ['#ffbc42', '#f09b00']; // 25% darken
  let betaColors = ['#adff5c', '#67d000'];

  let errorColorsNew = [
    "#FFFBFA",
    "#FEF3F2",
    "#FEE4E2",
    "#FECDCA",
    "#FDA29B",
    "#F97066",
    "#F04438",
    "#D92D20",
    "#B42318",
    "#912018",
    "#7A271A",
    "#55160C"
  ];

  let warningColorsNew = [
    "#FFFCF5",
    "#FFFAEB",
    "#FEF0C7",
    "#FEDF89",
    "#FEC84B",
    "#FDB022",
    "#F79009",
    "#DC6803",
    "#B54708",
    "#93370D",
    "#7A2E0E",
    "#4E1D09"
  ];

  let successColorsNew = [
    "#F6FEF9",
    "#ECFDF3",
    "#DCFAE6",
    "#ABEFC6",
    "#75E0A7",
    "#47CD89",
    "#17B26A",
    "#079455",
    "#067647",
    "#085D3A",
    "#074D31",
    "#053321"
  ];


  if (mode === "dark") {
    // primaryColors2 = [
    //   "#32221a",
    //   "#4a2b18",
    //   "#5e371b",
    //   "#7d4319",
    //   "#a85317",
    //   "#d26415",
    //   "#e9883a",
    //   "#f4a962",
    //   "#f8c48c",
    //   "#fbdbb5",
    // ];

    primaryColors = [
  "#1a2951",      
  "#244084",
  "#2549a8",
  "#2759ce",
  "#2f6de1",
  "#3681EB",
  "#458EF4",   // "#68abf2",
  "#98c8f8",
  "#c2ddfb",
  "#ddebfc"
    ]
    secondaryColors = [
      "#131920",
      "#1D2630",
      "#3E4853",
      "#5B6B79",
      "#8996A4",
      "#BEC8D0",
      "#DBE0E5",
      "#F3F5F7",
      "#F8F9FA",
      "#F8F9FA",
    ];
    errorColors = ["#321d1d", "#7d2e28", "#d13c31", "#e66859", "#f8baaf"];
    warningColors = ["#342c1a", "#836611", "#dda705", "#e9bf28", "#f8e577"];
    infoColors = ["#1a2628", "#11595f", "#058e98", "#1ea6aa", "#64cfcb"];
    successColors = ["#1a2721", "#115c36", "#05934c", "#1da65d", "#61ca8b"];
  }
  const palette = {
    primary: {
        lighter: primaryColors[0],
        100: primaryColors[1],
        200: primaryColors[2],
        light: primaryColors[3],
        400: primaryColors[4],
        main: primaryColors[5],
        dark: primaryColors[6],
        700: primaryColors[7],
        darker: primaryColors[8],
        900: primaryColors[9],
        contrastText
      },
      secondary: {
        lighter: secondaryColors[0],
        100: secondaryColors[1],
        200: secondaryColors[2],
        light: secondaryColors[3],
        400: secondaryColors[4],
        500: secondaryColors[5],
        main: secondaryColors[6],
        dark: secondaryColors[7],
        800: secondaryColors[8],
        darker: secondaryColors[9],
        contrastText
      },
      error: {
        lighter: errorColors[0],
        light: errorColors[1],
        main: errorColors[2],
        dark: errorColors[3],
        darker: errorColors[4],
        contrastText
      },
      warning: {
        lighter: warningColors[0],
        light: warningColors[1],
        main: warningColors[2],
        dark: warningColors[3],
        darker: warningColors[4],
        contrastText: secondaryColors[5]
      },
      info: {
        lighter: infoColors[0],
        light: infoColors[1],
        main: infoColors[2],
        dark: infoColors[3],
        darker: infoColors[4],
        contrastText
      },
      success: {
        lighter: successColors[0],
        light: successColors[1],
        // 200:'#ABEFC6',
        main: successColors[2],
        dark: successColors[3],
        darker: successColors[4],
        contrastText
      },
     

};
  return {
    primary: {
      25:primaryColors[0],
      lighter: primaryColors[1],
      100: primaryColors[2],
      200: primaryColors[3],
      light: primaryColors[4],
      400: primaryColors[5],
      main: primaryColors[6],
      dark: primaryColors[7],
      700: primaryColors[8],
      darker: primaryColors[9],
      900: primaryColors[10],
      950:primaryColors[11],
      contrastText
    },
    secondary: {
      lighter: secondaryColors[0],
      100: secondaryColors[1],
      200: secondaryColors[2],
      light: secondaryColors[3],
      400: secondaryColors[4],
      500: secondaryColors[5],
      main: secondaryColors[6],
      dark: secondaryColors[7],
      800: secondaryColors[8],
      darker: secondaryColors[9],
      contrastText,
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText,
      25: errorColorsNew[0],
      50: errorColorsNew[1],
      100: errorColorsNew[2],
      200: errorColorsNew[3],
      300: errorColorsNew[4],
      400: errorColorsNew[5],
      500: errorColorsNew[6],
      600: errorColorsNew[7],
      700: errorColorsNew[8],
      800: errorColorsNew[9],
      900: errorColorsNew[10],
      950: errorColorsNew[11],
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText: secondaryColors[5],
      25: warningColorsNew[0],
      50: warningColorsNew[1],
      100: warningColorsNew[2],
      200: warningColorsNew[3],
      300: warningColorsNew[4],
      400: warningColorsNew[5],
      500: warningColorsNew[6],
      600: warningColorsNew[7],
      700: warningColorsNew[8],
      800: warningColorsNew[9],
      900: warningColorsNew[10],
      950: warningColorsNew[11],
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText,
    },
    success: {
      // 50:'#ECFDF3',
      lighter: successColors[0],
      // 200:'#ABEFC6',
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      // 700:'#067647',
      contrastText,
      25: successColorsNew[0],
      50: successColorsNew[1],
      100: successColorsNew[2],
      200: successColorsNew[3],
      300: successColorsNew[4],
      400: successColorsNew[5],
      500: successColorsNew[6],
      600: successColorsNew[7],
      700: successColorsNew[8],
      800: successColorsNew[9],
      900: successColorsNew[10],
      950: successColorsNew[11],      
    },
    grey:{ 0: '#FFFFFF',
    100: '#F9FAFB',
    200: '#F4F6F8',
    300: '#DFE3E8',
    400: '#C4CDD5',
    500: '#919EAB',
    600: '#637381',
    700: 'rgb(109,124,136)',
    800: '#212B36',
    900: '#161C24',
  },
  white:{ lighter: '#fafafa',
    light: '#f1f1f1',
    main: '#fff',
    dark: '#fff',
    darker: '#fff',
    contrastText},
    background: {
      default: '#f8f9fa',
    },
    beta: {
      light: betaColors[0],
      main:betaColors[1],
      dark: betaColors[1]
    },
    dev: {
      light: devColors[0],
      main:devColors[1],
      dark: devColors[1]
    }
  };
};

export default Default;
